module.exports = __webpack_public_path__ + "img/pattern-footer.7f7ed7f5.png";